import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Skip" */ "../view/institution.vue")
  }
  // {
  //   path: "/institution",
  //   name: "Institution",
  //   component: () =>
  //     import(/* webpackChunkName: "Skip" */ "../view/institution.vue")
  // },
  // {
  //   path: "/user",
  //   name: "User",
  //   component: () => import(/* webpackChunkName: "Skip" */ "../view/user.vue")
  // }
];

const router = new VueRouter({
  routes
});

export default router;
